<template>
  <b-row>
    <!-- <b-col sm="12" md="12" lg="4">
      <b-pagination
        v-model="compCurrentPage"
        :total-rows="compRowCount"
        :per-page="compPerPage"
        first-number
        last-number
        aria-controls="table-tabela-proceda"
      />
    </b-col> -->

    <b-col sm="12" md="12" lg="4">
      <!-- compCurrentPage: {{ compCurrentPage }} / totalPages: {{ totalPages }} -->
      <ul class="pagination pagination-primary">
        <li class="page-item"
          :class="{ disabled: currentPage === 1 }">
          <a class="page-link" aria-label="Home" @click="homePage">
            <i class="material-icons">home</i>
          </a>
        </li>
        <li
          class="page-item prev-page"
          :class="{ disabled: currentPage === 1 }"
        >
          <a class="page-link" aria-label="Previous" @click="prevPage">
            <i class="material-icons">navigate_before</i>
            <!-- <i class="tim-icons icon-double-left" aria-hidden="true"></i> -->
          </a>
        </li>
        <li
          class="page-item page-pre next-page"
          :class="{ disabled: currentPage === totalPages }"
        >
          <a class="page-link" aria-label="Next" @click="nextPage">
            <i class="material-icons">navigate_next</i>
            <!-- <i class="tim-icons icon-double-right" aria-hidden="true"></i> -->
          </a>
        </li>
      </ul>
    </b-col>
    <b-col sm="12" md="12" lg="4">
      <label for="perPageSelect">
        {{ getPerPageSelectLabel }}
      </label>
    </b-col>
    <b-col sm="12" md="12" lg="4">
      <b-row>
        <b-col lg="8" class="text-md-left text-lg-right">
          <label for="perPageSelect"> Registros por página </label>
        </b-col>
        <b-col>
          <b-form-select
            v-model="compPerPage"
            id="perPageSelect"
            size="sm"
            :options="compPageOptions"
          />
        </b-col>
      </b-row>
      <!-- <b-form-group
        label-for="perPageSelect"
        label="Registros por página"
        label-class="label-top"
        label-cols-lg="8"
        label-align-lg="right"
        label-align-md="left"
      >
        <b-form-select
          v-model="compPerPage"
          id="perPageSelect"
          size="sm"
          :options="compPageOptions"
        />
      </b-form-group> -->
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    pageOptions: Array,
    perPage: Number,
    rowCount: Number,
  },
  computed: {
    getPaginationFrom() {
      return this.perPage * (this.currentPage - 1) + 1;
    },
    getPaginationTo() {
      let to = this.getPaginationFrom - 1 + this.perPage;
      if (to > this.rowCount) return this.rowCount;
      return to;
    },
    getPerPageSelectLabel() {
      return `Exibindo ${this.getPaginationFrom} até ${this.getPaginationTo} de um total de ${this.rowCount}`;
    },
    compPerPage: {
      get: function () {
        return this.perPage;
      },
      set: function (value) {
        this.$emit("onPageOptionsChanges", parseInt(value));
        this.$emit("update:perPage", parseInt(value));
      },
    },
    compCurrentPage: {
      get: function () {
        return this.currentPage;
      },
      set: function (value) {
        this.$emit("update:currentPage", parseInt(value));
      },
    },
    compRowCount: {
      get: function () {
        return this.rowCount;
      },
      set: function (value) {
        this.$emit("update:rowCount", parseInt(value));
      },
    },
    compPageOptions: {
      get: function () {
        return this.pageOptions;
      },
      set: function (value) {
        this.$emit("update:pageOptions", parseInt(value));
      },
    },
    totalPages() {
      return this.rowCount / this.perPage;
    },
  },
  methods: {
    homePage() {
      this.$emit("homePage", 1);
      this.compCurrentPage = 1;
    },
    nextPage() {
      this.$emit("nextPage", this.currentPage + 1);
      this.compCurrentPage++;
    },
    prevPage() {
      this.$emit("prevPage", this.currentPage - 1);
      this.compCurrentPage--;
    },
  },
};
</script>

<style scoped>
.label-top {
  padding-top: 1px !important;
}
</style>